<template>
  <div class="slider">
    <div class="slider-image-wrapper">
      <img
        :src="currentImage.imageUrl"
        :style="{ cursor: clickable ? 'pointer' : 'default' }"
        class="slider-image"
        @click="onImageClick"
      />
    </div>

    <button class="nav prev" @click="prev" v-if="images.length > 1">›</button>
    <button class="nav next" @click="next" v-if="images.length > 1">‹</button>
  </div>
</template>

<script>
export default {
  name: "ImageSlider",

  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
    clickable: false,
    type: "",
  },

  data() {
    return {
      currentIndex: 0,
      sliderInterval: null,
    };
  },

  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },

  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },

    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },

    goTo(index) {
      this.currentIndex = index;
    },

    onImageClick() {
      if (!this.clickable) return;
      if (this.type == "download") {
        this.downloadFile(this.currentImage.url);
      } else {
        localStorage.setItem("bannerId", this.currentImage.id);
        this.$router.push("/researcher/newUniRequestForm");
      }
    },
    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = ""; // let browser decide filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    startAutoSlide() {
      if (this.images.length <= 1) return;

      this.sliderInterval = setInterval(() => {
        this.next();
      }, 5000);
    },

    stopAutoSlide() {
      if (this.sliderInterval) {
        clearInterval(this.sliderInterval);
      }
    },
  },

  mounted() {
    this.startAutoSlide();
  },

  beforeDestroy() {
    this.stopAutoSlide();
  },
};
</script>

<style scoped>
.slider {
  position: relative;
  width: 100%;
  max-width: 100%;
}

.slider-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
  cursor: pointer;
}

.nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.4);
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}
</style>
